import { API } from '@/utils/API';

export type NotificationLevel = 'study' | 'site' | 'submission';

export interface LevelState {
  applicable: boolean;
  enabled: boolean;
  locked: boolean;
  source: 'user' | 'admin_override' | 'default' | null;
}

export interface NotificationTypeRow {
  notification_type: string;
  label: string;
  // Tooltip copy shown next to the label; null when the label says it all.
  description: string | null;
  category: string;
  mandatory: boolean;
  group: string | null;
  levels: Record<NotificationLevel, LevelState>;
}

export const notificationPreferencesQueryKey = ['notification-preferences'];

export const fetchNotificationPreferences = async (): Promise<
  NotificationTypeRow[]
> => {
  const response = await API.authenticated.fetch('/notification_preferences');

  if (!response.ok) {
    throw new Error('Failed to load notification preferences');
  }

  return response.json();
};

export const updateNotificationPreference = async (
  notificationType: string,
  level: NotificationLevel,
  enabled: boolean
): Promise<void> => {
  const response = await API.authenticated.fetch(
    `/notification_preferences/${notificationType}`,
    {
      method: 'PUT',
      body: JSON.stringify({ level, enabled }),
    }
  );

  if (!response.ok) {
    const data = await response.json();
    throw new Error(data.errors || 'Failed to update notification preference');
  }
};
